import TemplateView from '../../../TemplateView'

export default class WelcomeScreenLightboxHeader extends TemplateView
{
    constructor({
        loadExternalWelcomeScreen,
        showCloseButton = true,
    }) {
        super()
        this.params = {
            loadExternalWelcomeScreen,
            showCloseButton,
        }
    }

    templateHtml() {
        return `<div></div>`
    }

    getCloseButtonEl() {
        return this.find('.close-button')
    }

    templateHtml() {
        return this.params.loadExternalWelcomeScreen
            ? `<div class="dialog-header dialog-header-empty">
                ${this.params.showCloseButton
                    ? `<div class="close-button">
                          <div id="closeProjectLightBoxBtn" class="closeButton"></div>
                          <div class="disabledCloseButton"></div>
                      </div>`
                    : ''}
                </div>`
            : `<table class="dialog-header">
                  <tr>
                      <td>
                ${this.params.showCloseButton
                    ?    `<div class="close-button">
                              <div id="closeProjectLightBoxBtn" class="closeButton"></div>
                              <div class="disabledCloseButton"></div>
                          </div>`
                    : ''}
                          <div class="lightBoxTitle">
                          </div>
                      </td>
                  </tr>
              </table>`
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightboxHeader.js